/**
 * Error boundary for Micro Frontend (MFE) remote components.
 *
 * Wraps any remote component loaded via Module Federation (oap_web, mf_commerce, etc.)
 * so that render or lifecycle errors (e.g. missing property after an MFE deploy) are
 * contained: the boundary shows a non-blocking fallback UI and logs the error instead
 * of crashing the whole page.
 *
 * @example
 * // Typical pattern: SafeSuspense for lazy loading, MFEErrorBoundary for runtime errors
 * <SafeSuspense fallback={<Loader />}>
 *   <MFEErrorBoundary>
 *     <RemoteCommerceComponent {...props} />
 *   </MFEErrorBoundary>
 * </SafeSuspense>
 *
 * @see docs/MFE_ERROR_BOUNDARY.md for full usage and limitations
 */
import { NonBlockingErrorBoundary } from '@calendly/error-boundary'
import { Logger } from '@calendly/logging-service'

export const MFEErrorBoundary = ({ children }) => (
  <NonBlockingErrorBoundary logger={Logger}>
    {children}
  </NonBlockingErrorBoundary>
)
